import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StateService, AuthService, RoleService } from '../../services';
import { Authenticate, RoleModel } from '../../models';
import { FormFunctions } from '../../functions';
import { state } from '@angular/animations';

@Component({
    selector: 'page-register',
    templateUrl: './page-register.component.html',
    styleUrls: ['./page-register.component.scss']
})
export class PageRegisterComponent implements OnInit {
    request: Authenticate = new Authenticate();
    status: string = "";
    uniqueToken: string = "";
    isTokenLogin: boolean = false;
    processing: boolean = false;

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public stateService: StateService, public authService: AuthService, public formFunctions: FormFunctions, public roleService: RoleService) {
        var me = this;
        me.status = me.activatedRoute.snapshot.params.status;
        me.uniqueToken = me.activatedRoute.snapshot.params.uniqueToken;
        me.isTokenLogin = me.activatedRoute.snapshot.params.uniqueToken != null;
    }

    ngOnInit() {
        var me = this;

    }

    loginCallback(userId) {
        var me = this;
        me.processing = true;
        me.roleService.FindMyRoles().subscribe(data => {
            me.processing = false;
            if (data.length) {
                // let role: RoleModel = data[0];
                // let roleName = role.Name.toLowerCase();
                me.navigateHome(data);
            }
        });
    }
    navigateHome(roles) {
        let me = this;

        const { redirect } = window.history.state;
        me.router.navigateByUrl(this.activatedRoute.snapshot.queryParams.returnUrl || redirect || '/');
    }

    TokenLogin() {
        let me = this;
        let tokenRequest = new Authenticate();
        tokenRequest.UniqueId = me.uniqueToken;
        me.authService.Login(tokenRequest).subscribe(data => {
            me.stateService.changeUserModel(data.Data);
            me.roleService.FindMyRoles().subscribe(data => {
                me.processing = false;
                if (data.length) {
                    me.navigateHome(data);
                }
            });
        });
    }

    Logout() {
        let me = this;
        me.stateService.changeUserModel(null);
        me.router.navigate(['/']);
    }
}
